import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

interface IProps {
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  TextOverride?: React.ReactNode;
}

//For default case, we would show a continue with arrow for next view
//But circumstances might apply where we want to show a different text
export const ContinueToNextViewButton: React.FC<IProps> = ({
  className,
  disabled = false,
  isLoading = false,
  onClick,
  TextOverride,
}) => (
  <Button
    onClick={onClick}
    data-test-id="continueButton"
    className={className}
    disabled={disabled}
    loading={isLoading}
  >
    {TextOverride ? (
      TextOverride
    ) : (
      <StrictLocalMsg
        id="83XsId"
        defaultMessage="Next"
        description={{ text: "Submit and continue to the next step" }}
      />
    )}
  </Button>
);
